import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoaderService } from "../../service/loader.service";
import { Message } from "../../service/message.service";
import { RestService } from "../../service/rest.service";
import { api } from "../../../environments/environment";

@Component({
  selector: "app-catalog-companies",
  templateUrl: "./catalogCompanies.component.html",
  styles: [],
  standalone: false,
})
export class CatalogCompaniesComponent implements OnInit {
  constructor(
    private router: Router,
    private message: Message,
    private rest: RestService,
    private loader: LoaderService
  ) { }

  currentPage = 1
  totalPages = 1
  currentPageProducts = 1
  totalPagesProducts = 1
  companies :any[]= []
  baseUrl = api.baseUrl
  currentCompany :any
  productsCompany :any[] = []
  showModalRequest = false
  showModalInfo = false;
  myItem : any
  categories : any[] = []
  currentCategory :any
  subjectEmail = ''
  descriptionEmail = ''

  ngOnInit(): void {
    this.getCategories()
  }

  getCategories(){
    let options = {
      page: 1,
      limit:9999
    };
    this.loader.on()
    this.rest.get(`/category?options=${JSON.stringify(options)}`).subscribe({
      next:(value:any)=> {
        this.categories = value.data
        
        this.loader.off(true)
      },
      error:(value)=> {
        this.loader.off(true)
      },
    })
  }

  getCompanies(){
    let options = {
      page: this.currentPage,
      filters: [
        { s: "role", v: 6, o: 1 }
      ],
    };
    this.loader.on()
    this.rest.get(`/user?options=${JSON.stringify(options)}`).subscribe({
      next:(value:any)=> {
        this.currentPage = value.currentPage
        this.totalPages = value.totalPages
        this.companies = value.data
        this.loader.off(true)
      },
      error:(value)=> {
        this.loader.off(true)
      },
    })
  }

  showCompanyProducts(company:any){
    this.currentCompany = company
    this.getCompanyProducts()
  }

  getCompanyProducts(){
    let options = {
      page: this.currentPageProducts,
      limit:9999,
      filters: [
        { s: "category", v: [this.currentCategory.id] }
      ],
    };
    this.loader.on()
    this.rest.get(`/catalog?options=${JSON.stringify(options)}`).subscribe({
      next:(value:any)=> {
        this.currentPageProducts = value.currentPage
        this.totalPagesProducts = value.totalPages
        this.productsCompany = value.data
        // if(value.data.length == 0){
        //   this.message.showMessage("Questa categoria non ha aziende","error")
        // }
        this.loader.off(true)
      },
      error:(value)=> {
        this.loader.off(true)
      },
    })
  }
  
  join(item: any) {
    this.showModalRequest = false
    this.loader.on()
    this.rest.post('/tech/' + item.id + '/request', {
      catalogId: item.id,
      techId: item.user.id,
      subject:this.subjectEmail,
      description:this.descriptionEmail
    }).subscribe({
      next: (value: any) => {
        this.message.showMessage('Hai contattato con successo', 'success')
        this.loader.off()
      },
      error: (value: any) => {
        if (value.status == 409) {
          this.message.showMessage(value.error.message, 'error')
        }
        this.loader.off()
      },
    })
  }

  formatWebsite(url: string): string {
    if (!url || url === 'null') return '';

    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return 'https://' + url;
    }
    return url;
  }
}
